module.exports = __webpack_public_path__ + "media/images/front/products/standard/product_7-db5ea3631ef632ae012fdef82e65a332.jpg";